import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import { AuthenticatedExternalUserRoutes } from "_constants/PageRoutes";
import { PageHelper } from '_helpers/PageHelper';
import MCSOverlayLoading from 'components/MCSOverlayLoading';
import ManageSubscriptionDisclaimer from "components/subscription/ManageSubscriptionDisclaimer";
import { GlobalAlertContext } from 'context/GlobalAlertContext';
import { cloneDeep } from "lodash";
import React, { useContext, useState } from 'react';
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory } from "react-router-dom";
import { SubscriptionApi } from 'services/subscription.service';
import SubscriptionsTable from './Components/SubscriptionsTable';
import ErrorPage from "pages/Error/ErrorPage";

function Subscriptions(props) {
    const alertContext = useContext(GlobalAlertContext);
    const history = useHistory();
    const { promiseInProgress } = usePromiseTracker();
    const [error, setError] = useState(null);
    const [orgProductSubscriptionsData, setOrgProductSubscriptionsData] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [filter, setFilter] = useState({ search: "", subscriptionStatus: null });
    const PAGE_SIZE = 10; const ordered = "createdOn"; const desc = true;
    const queryString = require('query-string');

    const handleClickAction = (s) => {
        history.push({
            pathname: AuthenticatedExternalUserRoutes.SUBSCRIPTION_DETAILS,
            state: {
                subscriptionId: s.id,
            },
        });
    };

    const handleTablePageChange = async (page, filter, orderBy, desc) => {
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page);
        
        trackPromise(
            SubscriptionApi
                .UserGetOrganizationProductSubcriptionList(skipCount, orderBy, desc, filter)
                .then((result) => {
                    var response = result.data;
                    setOrgProductSubscriptionsData(response.items);
                    setTotalCount(response.totalCount);
                    setTotalPages(PageHelper.GetTotalCountToPages(PAGE_SIZE, response.totalCount));
                })
                .catch((error) => {
                    setError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    }

    function getOrderRefQuery() {
        var query = props.location.search;
        if (query.trim() !== "") {
            var queryItems = queryString.parse(query);
            return queryItems.orderRef;
        }
    }

    function processParams(filter) {
        if (filter === null) return null;
        let process = cloneDeep(filter);
        return process;
    }

    React.useEffect(() => {
        var orderRef = getOrderRefQuery();
        if (orderRef != null && orderRef !== "") {
            setFilter({ ...filter, search: orderRef });
            let searchFilter = processParams(filter);
            searchFilter.search = orderRef;
            handleTablePageChange(1, searchFilter, ordered, desc);
        } else {
            handleTablePageChange(1, filter, ordered, desc);
        }
    }, []);

    if (error) {
        return <ErrorPage text={error.message} />;
    }

    return (
        <>
            {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
            <GlobalAlertContext.Consumer>
                {() => (
                    <>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">View Subscriptions</Typography>
                                </Col>
                            </Row>
                            <ManageSubscriptionDisclaimer />
                            <Row>
                                <SubscriptionsTable
                                    fetch={handleTablePageChange}
                                    tableData={orgProductSubscriptionsData} pageSize={PAGE_SIZE} totalCount={totalCount} totalPages={totalPages}
                                    ordered={ordered} isDsc={desc} filter={filter} setFilter={setFilter}
                                    handleClickAction={handleClickAction}
                                />
                            </Row>
                        </Grid>
                    </>)}
            </GlobalAlertContext.Consumer>
        </>
    );
}


export default Subscriptions;
